import { Component, ViewChild, OnInit, Output, ViewEncapsulation, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository, WindowRef } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { KhoaHocs_KhoaHoc } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'
import { EmitType, detach } from '@syncfusion/ej2-base';
import { UploaderComponent, RemovingEventArgs, SelectedEventArgs, SuccessEventArgs, FileInfo } from '@syncfusion/ej2-angular-inputs';

import { DialogComponent, ButtonPropsModel, PositionDataModel, ResizeDirections } from '@syncfusion/ej2-angular-popups';
import { AnimationSettingsModel } from '@syncfusion/ej2-splitbuttons';

import { SelectionService, EditService, SelectionSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { MaskedDateTimeService } from '@syncfusion/ej2-angular-calendars';
import { ToolbarService, LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';
import { RichTextEditorComponent, TableService, FileManagerService } from '@syncfusion/ej2-angular-richtexteditor';
import { FileManagerSettingsModel, QuickToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import { createElement, addClass, removeClass, Browser } from '@syncfusion/ej2-base';
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { FileManagerComponent, FileOpenEventArgs, FileSelectEventArgs } from '@syncfusion/ej2-angular-filemanager';
import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import { MaskedTextBoxComponent } from '@syncfusion/ej2-angular-inputs';
import { load } from '@progress/kendo-angular-intl';

const swal = require('sweetalert');
@Component({
  selector: 'app-dieuhanh-hocvientiemnangedit',
  templateUrl: './hocvientiemnangedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./hocvientiemnangedit.component.scss'],
  providers: [ListService, Repository, WindowRef, MaskedDateTimeService, ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService],
  encapsulation: ViewEncapsulation.None
})


export class hocvientiemnangeditComponent implements OnInit {
  @ViewChild('modal')
  modal: BsModalComponent;
  @ViewChild('dteChonTaiKhoan') dteChonTaiKhoan: any;

  @ViewChild('mdDanhSachLichHoc') mdDanhSachLichHoc: BsModalComponent;
  @ViewChild('dtedslichhocedit') dtedslichhocedit: any;
  @ViewChild('ejNgaySinh') public ejNgaySinh: MaskedTextBoxComponent;
  public formatDateVao = '00/00/0000';
  public formatDateRa = '00/00/0000';
  public formatDate = '00/00/0000';

  inputtrangthais: any = [
    { Id: 1, Ten: 'Mới' }
    , { Id: 9, Ten: 'Không nghe máy' }
    , { Id: 10, Ten: 'Gọi lại sau' }
    , { Id: 5, Ten: 'Quan tâm' }
    , { Id: 12, Ten: 'Tiềm năng' }
    , { Id: 13, Ten: 'Không tiềm năng' }
    , { Id: 2, Ten: 'Đợi học thử' }
    , { Id: 4, Ten: 'Đang học thử' }
    , { Id: 16, Ten: 'Đã học thử' }
    , { Id: 8, Ten: 'Đợi test' }
    , { Id: 3, Ten: 'Đợi đăng ký' }
    , { Id: 7, Ten: 'Đã đăng ký' }
    , { Id: 14, Ten: 'Hủy lịch học thử' }
    , { Id: 11, Ten: 'Hủy lịch test' }
    , { Id: 15, Ten: 'Đã test' }
    , { Id: 6, Ten: 'Không có nhu cầu' }
  ];

  dviid: string;
  inputhinhthucdaotaos: any = [];
  inputchungchis: any = [];
  inputGiangViens: any;
  inputkhuvucs: any;
  items = [];
  donviitems = [];
  datas = [];
  inputgioitinhs: any = [{ Id: 1, Name: 'Nam' }, { Id: 2, Name: 'Nữ' }]
  inputphanloais = [{ Id: 0, Ten: 'Dài hạn' }, { Id: 1, Ten: 'Không thường xuyên' }
  ];
  inputtinhtrangs = [{ Id: 0, Ten: 'Dự kiến' }, { Id: 1, Ten: 'Chính thức' }
  ];
  inputphonghocs: any;

  private hostUrl: string = '/';
  // upload
  @ViewChild('uploadObj')
  public uploadObj: UploaderComponent;
  @ViewChild('dialogObj')
  public dialogObj: DialogComponent;
  @ViewChild('filemanagerObj')
  public filemanagerObj: FileManagerComponent;
  public dialogHeader = 'Chọn tệp ảnh';
  public animationSettings: Object = { effect: 'None' };
  public showCloseIcon = true;
  public target = '#target';
  public visible = false;
  public dialogWidth = '850px';
  public contextmenuItems: string[] = ['Open', '|', 'Cut', 'Copy', 'Delete', 'Rename', '|', 'Details'];
  ajaxSettings = {
    url: this.hostUrl + 'FileUpLoadManager/FileOperations',
    getImageUrl: this.hostUrl + 'FileUpLoadManager/GetImage',
    uploadUrl: this.hostUrl + 'FileUpLoadManager/Upload',
    downloadUrl: this.hostUrl + 'FileUpLoadManager/Download'
  };
  public btnClick: EmitType<object> = () => {
    //if (document.getElementById('target').classList.contains('upload-dialog1')) {
    //  document.getElementById('target').classList.remove('upload-dialog1');
    //}
    //document.getElementById('target').classList.add('upload-dialog');
    this.dialogObj.show();
    this.dialogOpen();
    this.filemanagerObj.path = '/';
    this.filemanagerObj.selectedItems = [];
    this.filemanagerObj.refresh();
  }

  // Uploader will be hidden, if Dialog is opened
  public dialogOpen: EmitType<object> = () => {
    document.getElementById('uploadFileManager').style.display = 'none';
  }
  // Uploader will be shown, if Dialog is closed
  public dialogClose: EmitType<object> = () => {
    document.getElementById('uploadFileManager').style.display = 'block';
  }
  OnbeforeSend(args) {

    var data = JSON.parse(args.ajaxSettings.data);
    if (args.action == 'Upload') {
      //data[0]["CodeClass"] = this.codeClass;
      //data[0]["Loai"] = 1;
      data.push({ codeclass: 'ThuVien' });
      data.push({ PathFolder: "~/Upload/ThuVien" });
      data.push({ loai: 1 });
      args.ajaxSettings.data = JSON.stringify(data);
    }
    else {
      data["CodeClass"] = 'ThuVien';
      data["DonVi"] = null;
      data["PathFolder"] = "~/Upload/ThuVien";
      data["Loai"] = 1;
      args.ajaxSettings.data = JSON.stringify(data);
    }

  };
  // File Manager's fileOpen event function
  public onFileOpen(args: FileOpenEventArgs): void {
    let file = (args as any).fileDetails;
    if (file.isFile) {
      args.cancel = true;
      if (file.size <= 0) { file.size = 10000; }
      this.uploadObj.files = [{ name: file.name, size: file.size, type: file.type }];
      // let filterPath = "/Content/Files" + file.filterPath.replace('\\', '/') + file.name;
      let filterPath = '/Upload/ThuVien' + '/' + file.filterPath.replace('\\', '/').replace('\\', '/').replace('\\', '/').replace('\\', '/') + '/' + file.name;
      this.hosoSelect.DuongDanAnh = filterPath;
      this.dialogObj.hide();
      //if (document.getElementById('target').classList.contains('upload-dialog')) {
      //  document.getElementById('target').classList.remove('upload-dialog');
      //}
      //document.getElementById('target').classList.add('upload-dialog1');

    }
  }
  public ngOnDestroy(): void {
    if (document.getElementById('target').classList.contains('upload-dialog')) {
      document.getElementById('target').classList.remove('upload-dialog');
    }
  }

  toolbarSettings = {
    items: ['NewFolder', 'Upload', 'Delete', 'Cut', 'Copy', 'Rename', 'SortBy', 'Refresh', 'Selection', 'View', 'Details']
  };
  contextMenuSettings = {
    file: this.contextmenuItems,
    folder: this.contextmenuItems
  };
  taifile(src: string) {
    console.log(src);
    window.location.href = src;
  }
  deleteFile() {
    this.hosoSelect.DuongDanAnh = null;
  }

  // upload




  alertMsg: any;
  @ViewChild('toolsRTE')
  public rteObj: RichTextEditorComponent;
  public tools: ToolbarModule = {
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', 'SuperScript', 'SubScript', '|',
      'Formats', 'Alignments', 'NumberFormatList', 'BulletFormatList',
      'Outdent', 'Indent', '|',
      'CreateTable', 'CreateLink', 'Image', 'FileManager', '|', 'ClearFormat', 'Print',
      'SourceCode', 'FullScreen', '|', 'Undo', 'Redo']
  };

  public fileManagerSettings: FileManagerSettingsModel = {
    enable: true,
    path: '',
    ajaxSettings: {
      url: this.hostUrl + 'FileUpLoadManager/FileOperations',
      getImageUrl: this.hostUrl + 'FileUpLoadManager/GetImage',
      uploadUrl: this.hostUrl + 'FileUpLoadManager/Upload',
      downloadUrl: this.hostUrl + 'FileUpLoadManager/Download'
    }
  };





  public quickToolbarSettings: QuickToolbarSettingsModel = {
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public width: string = '98%';
  // public animationSettings: AnimationSettingsModel = { effect: 'None' };
  // public target: string = '.control-section';
  public maxLength = 20000;
  public textArea: HTMLElement;
  public myCodeMirror: any;
  public value: any;


  public mirrorConversion(e?: any): void {
    const id: string = this.rteObj.getID() + 'mirror-view';
    let mirrorView: HTMLElement = this.rteObj.element.querySelector('#' + id) as HTMLElement;
    const charCount: HTMLElement = this.rteObj.element.querySelector('.e-rte-character-count') as HTMLElement;
    if (e.targetItem === 'Preview') {
      this.textArea.style.display = 'block';
      mirrorView.style.display = 'none';
      this.textArea.innerHTML = this.myCodeMirror.getValue();
      charCount.style.display = 'block';
    } else {
      if (!mirrorView) {
        mirrorView = createElement('div', { className: 'e-content' });
        mirrorView.id = id;
        this.textArea.parentNode.appendChild(mirrorView);
      } else {
        mirrorView.innerHTML = '';
      }
      this.textArea.style.display = 'none';
      mirrorView.style.display = 'block';
      this.renderCodeMirror(mirrorView, this.rteObj.value);
      charCount.style.display = 'none';
    }
  }

  public renderCodeMirror(mirrorView: HTMLElement, content: string): void {
    this.myCodeMirror = CodeMirror(mirrorView, {
      value: content,
      lineNumbers: true,
      mode: 'text/html',
      lineWrapping: true,

    });
  }
  public handleFullScreen(e: any): void {
    const sbCntEle: HTMLElement = document.querySelector('.sb-content.e-view');
    const sbHdrEle: HTMLElement = document.querySelector('.sb-header.e-view');
    const leftBar: HTMLElement = document.querySelector('#left-sidebar');
    if (e.targetItem === 'Maximize') {
      if (Browser.isDevice && Browser.isIos) {
        addClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      addClass([leftBar], ['e-close']);
      removeClass([leftBar], ['e-open']);
    } else if (e.targetItem === 'Minimize') {
      if (Browser.isDevice && Browser.isIos) {
        removeClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      removeClass([leftBar], ['e-close']);
      if (!Browser.isDevice) {
        addClass([leftBar], ['e-open']);
      }
    }
  }
  public actionCompleteHandler(e: any): void {
    console.log("actiondsdsd");
    console.log(e);
    if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
      (this.rteObj.sourceCodeModule.getPanel() as HTMLTextAreaElement).style.display = 'none';
      this.mirrorConversion(e);
    } else {
      setTimeout(() => {
        this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
        this.rteObj.toolbarModule.refreshToolbarOverflow();
      }, 400);

    }
  }



  public ngaybatdau: Date = null;
  public ngayketthuc: Date = null;

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputloaicauhois: any
  indLoading: boolean = false;
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
   bledit: boolean = false;
  currentUser: any;
  dschinhanhs: any;
  dschuongtrinhs: any;
  inputtrinhdos: any;
  inputkenhs: any;
  inputhedaotaos: any;
 
  dslops: any;


  hosoSelect: any = {
    Id: null, MaHoSo: null, MaNV: null, HoVaTen: null, TenGoiKhac: null, NgaySinh: null, NgaySinh_S: null, KieuNgaySinh: 1, GioiTinh: null, NoiSinh: null, NoiSinhId: null, NguyenQuan: null, NguyenQuanId: null,
    DanTocId: null, HoKhauThuongTru: null, HoKhauThuongTruId: null, ChoOHienTai: null, ChoOHienTaiId: null, DienThoaiBan: null, DienThoaiNhaRieng: null, DienThoaiDiDong: null, NgheNghiepTuyenDung: null,
    CoQuanTuyenDung: null, NgayVaoNN: null, NgayVaoNganh: null, NgayRaNganh: null, CongViecDuocGiao: null, NgayCTXH: null, CongViecCTXH: null, SoTruongCongTac: null, ChungChiTiengDT: null,
    DaoTaoAN: null, DaoTaoQP: null, ThanhPhanGiaDinhId: null, NgayTuyenDung: null, NgayTuyenDung_S: null,
    SucKhoeId: null, NhomMauId: null,// dữ liệu này text
    CanNang: null, DoiTuongChinhSachId: null, HangThuongBinh: null, SoCMND: null, NgayCapCMND: null, NoiCapCMND: null,
    LoaiNhanVienId: null, DonViId: null, BoPhanId: null, ChucVuId: null, TonGiaoId: null,
    NoiSinhIdSelect: null, NguyenQuanIdSelect: null, ChoOHienTaiIdSelect: null, HoKhauThuongTruIdSelect: null, SoHieu: null
    , ImageUrl: null, ChieuCao: null, Created: null, CreatedBy: null, Modified: null, ModifiedBy: null, NgayNghiViec: null

    , Email: null, TrinhDo: null, NguyenVong: null, NguonKenh: null, TruongHoc: null, HeDaoTao: null
    , NameParent: null, PhoneParent: null, FacebookParent: null
    , NameDad: null, PhoneDad: null, FacebookDad: null, ElearningBegin: null, ElearningEnd: null
    , LopId: null, IdConsult: null, Notes: null, TaiKhoan: null, MatKhau: null
    , DSLop: [], DoTuoi: null, IDLocations: null

    //, DSLoaiCanBo: null
  };
  nhomdtid: string = null;
  hoatdong: string = null;
  inputloais: any = [{ Id: 0, Ten: 'Đúng sai' }, { Id: 1, Ten: 'Một lựa chọn' }, { Id: 2, Ten: 'Nhiều lựa chọn' }, { Id: 3, Ten: 'Tự luận' }]

  inputmonhocs: any;
  inputloaikhoanluongs: any = [{ Id: 1, Name: 'Thu nhập thường xuyên' }, { Id: 2, Name: 'Thu nhập không thường xuyên' }, { Id: 3, Name: 'Khấu trừ thường xuyên' }, { Id: 4, Name: 'Khấu trừ không thường xuyên' }]
  inputloaikieunhaps: any = [{ Id: 1, Name: 'Số tiền' }, { Id: 2, Name: 'Tỷ lệ (%)' }, { Id: 3, Name: 'Hệ số' }]
  inputloaikhoans: any;
  inputloaithis: any;
  inputtaikhoantaisans: any;
  inputmucdocauhois: any;

  file: any;
  idnew: string;
  hienthianh: any;

  @Output() save: EventEmitter<any> = new EventEmitter();

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };


  constructor(private _dataService: ListService, public repo: Repository) {


  }

  ngOnInit(): void {
    document.getElementById('target').classList.add('upload-dialog1');
    document.getElementById('defaultfileupload').style.display = 'none';
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngAfterViewInit() {


    //setTimeout(() => {
    //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
    //  this.rteObj.toolbarModule.refreshToolbarOverflow();
    //}, 400);


  }




  // @HostListener('document:keydown', ['$event'])
  // public handleKeyboardEvent(event: KeyboardEvent): void {

  //   if(event.key==="F9")
  //   {
  //       this.saveproduct();
  //   }
  //   event.stopPropagation();

  // }
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return  item.Ten.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  phanheid: string;
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, lopid: string, tenlop: string) {

    
    this.phanheid = nhomdoituongid;

    this.dviid = donviid;
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {
      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }

      this.repo.getRequest("api/hoso/combohangmuc/")
        .subscribe(response => {
          this.items = response;

        });
      this.repo.getRequest("api/hoso/donvicaylist/", { phanloaiId: -1, giaithe: 1 })
        .subscribe(response => {
          this.donviitems = response;

        });
      this.repo.postRequest("api/hoso/combonhansuhotro", { DonViId: this.dviid})
        .subscribe(response => {
          this.inputGiangViens = response;
        });
      this.repo.postRequest("api/khuvuc/GetDS", { DonViId: this.dviid })
        .subscribe(response => {
          this.inputkhuvucs = response;
        });
      

      this.repo.getRequest("api/hoso/conmonlist/", { entityName: 'DM_HinhThucDaoTao' })
        .subscribe(response => {
          this.inputhinhthucdaotaos = response;
        });
      this.repo.getRequest("api/hoso/combochungchi/")
        .subscribe(response => {
          this.inputchungchis = response;
        });

      this.repo.postRequest('api/login/gettrungtam2s', { UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.dschinhanhs = response;
          
        });

      this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: this.dviid })
        .subscribe(response => {
          this.dslops = response;

        });


    }
  

    //this.hosoSelect.AnhString = null;
    this.hienthianh = false;
    $('#preview').attr('src', "/assets/img/anhdt.gif");


    this.hosoSelect = {
      Id: null, MaHoSo: null, MaNV: null, HoVaTen: null, TenGoiKhac: null, NgaySinh: null, NgaySinh_S: null, KieuNgaySinh: 1, GioiTinh: null, NoiSinh: null, NoiSinhId: null, NguyenQuan: null, NguyenQuanId: null,
      DanTocId: null, HoKhauThuongTru: null, HoKhauThuongTruId: null, ChoOHienTai: null, ChoOHienTaiId: null, DienThoaiBan: null, DienThoaiNhaRieng: null, DienThoaiDiDong: null, NgheNghiepTuyenDung: null,
      CoQuanTuyenDung: null, NgayVaoNN: null, NgayVaoNganh: null, NgayRaNganh: null, CongViecDuocGiao: null, NgayCTXH: null, CongViecCTXH: null, SoTruongCongTac: null, ChungChiTiengDT: null,
      DaoTaoAN: null, DaoTaoQP: null, ThanhPhanGiaDinhId: null, NgayTuyenDung: null, NgayTuyenDung_S: null,
      SucKhoeId: null, NhomMauId: null,// dữ liệu này text
      CanNang: null, DoiTuongChinhSachId: null, HangThuongBinh: null, SoCMND: null, NgayCapCMND: null, NoiCapCMND: null,
      LoaiNhanVienId: null, DonViId: this.dviid, BoPhanId: null, ChucVuId: null, TonGiaoId: null,
      NoiSinhIdSelect: null, NguyenQuanIdSelect: null, ChoOHienTaiIdSelect: null, HoKhauThuongTruIdSelect: null, SoHieu: null
      , ImageUrl: null, ChieuCao: null, Created: null, CreatedBy: null, Modified: null, ModifiedBy: null, NgayNghiViec: null

      , Email: null, TrinhDo: null, NguyenVong: null, NguonKenh: null, TruongHoc: null, HeDaoTao: null
      , NameParent: null, PhoneParent: null, FacebookParent: null
      , NameDad: null, PhoneDad: null, FacebookDad: null, ElearningBegin: null, ElearningEnd: null
      , LopId: null, IdConsult: null, Notes: null, TaiKhoan: null, MatKhau: null
      , DSLop: [], DoTuoi: null, IDLocations: null
    };
    this.ngaybatdau = null;
    this.ngayketthuc = null;

    this.hosoSelect.DonViId = parseInt(this.dviid);

    if (id === null) {


      this.hosoSelect.Created = new Date();
      this.hosoSelect.CreatedBy = this.currentUser.user_name;
      this.hosoSelect.Modified = new Date();
      this.hosoSelect.ModifiedBy = this.currentUser.user_name;

      if (lopid != null)
        this.hosoSelect.DSLop.push(parseInt(lopid));

      //this.hosoSelect.PhanLoai = 0;
      //this.hosoSelect.TinhTrang = 1;
      //this.hosoSelect.TrangThai2 = true;

      //this.repo.postRequest("api/daotao/getthongtinhoso/", { id: null, status: this.dviid })
      //  .subscribe(response => {
      //    this.hosoSelect.Ma = response.MaLop;
      //  });

      //setTimeout(() => {
      //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
      //  this.rteObj.toolbarModule.refreshToolbarOverflow();
      //}, 400);
    }
    else {
      this.bledit = true;
      console.log("t11");
      this.repo.postRequest("api/tuyensinh/mb_getthongtinhoso/", { id: id, status: 0 })
        .subscribe(response => {
          this.hosoSelect = response;

          if (this.hosoSelect.NgaySinh != null)
            this.hosoSelect.NgaySinh = new Date(this.hosoSelect.NgaySinh);
          else
            this.hosoSelect.NgaySinh = null;

          if (this.hosoSelect.NgayNghiViec != null)
            this.hosoSelect.NgayNghiViec = new Date(this.hosoSelect.NgayNghiViec);
          else
            this.hosoSelect.NgayNghiViec = null;

          if (this.hosoSelect.NgayVaoDang != null)
            this.hosoSelect.NgayVaoDang = new Date(this.hosoSelect.NgayVaoDang);
          else
            this.hosoSelect.NgayVaoDang = null;

          if (this.hosoSelect.NgayRaDang != null)
            this.hosoSelect.NgayRaDang = new Date(this.hosoSelect.NgayRaDang);
          else
            this.hosoSelect.NgayRaDang = null;
          if (this.hosoSelect.NgayVaoDangCT != null)
            this.hosoSelect.NgayVaoDangCT = new Date(this.hosoSelect.NgayVaoDangCT);
          else
            this.hosoSelect.NgayVaoDangCT = null;
          if (this.hosoSelect.NgayCapTheDang != null)
            this.hosoSelect.NgayCapTheDang = new Date(this.hosoSelect.NgayCapTheDang);
          else
            this.hosoSelect.NgayCapTheDang = null;
          if (this.hosoSelect.NgayVaoDoan != null)
            this.hosoSelect.NgayVaoDoan = new Date(this.hosoSelect.NgayVaoDoan);
          else
            this.hosoSelect.NgayVaoDoan = null;
          if (this.hosoSelect.Id === 0)
            this.hosoSelect.TonGiaoId = 1609;

          if (this.hosoSelect.ElearningBegin != null)
            this.hosoSelect.ElearningBegin = new Date(this.hosoSelect.ElearningBegin);
          else
            this.hosoSelect.ElearningBegin = null;
          if (this.hosoSelect.ElearningEnd != null)
            this.hosoSelect.ElearningEnd = new Date(this.hosoSelect.ElearningEnd);
          else
            this.hosoSelect.ElearningEnd = null;


          //this.hosoSelect.Created = response.Created;
          //this.hosoSelect.CreatedBy = response.CreatedBy;
          this.hosoSelect.Modified = new Date();
          this.hosoSelect.ModifiedBy = this.currentUser.user_name;

          //setTimeout(() => {
          //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
          //  this.rteObj.toolbarModule.refreshToolbarOverflow();
          //}, 400);

        });
    }



  }
  Tai_Anh() {

    this.hosoSelect.XoaAnh = 1;
    $("#File").click();
  }
  Xoa_Anh() {

    this.hosoSelect.XoaAnh = 0;
    $('#preview').attr('src', "/assets/img/anhdt.gif");
  }
  getFiles(event) {
    console.log("tt");
    //console.log(event);
    this.file = event.target.files;
    if (!this.file[0].type.match("image.*")) {
      alert("Tệp chọn không phải kiểu ảnh.");
      event.srcElement.value = null;
      return;
    }

    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsBinaryString(this.file[0]);

  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.hosoSelect.AnhString = btoa(binaryString);  // Converting binary string data.

    $('#preview').attr('src', "data:image/png;base64," + this.hosoSelect.AnhString + "");

  }
  //  keyTenPress(event: any) { 
  //      if (event.which === 13) {
  //        this.slLoaiKhoanLuong.focus();
  //          event.preventDefault();
  //        }
  //}

  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    if (this.hosoSelect.Id == null)
      this.hosoSelect.Id = 0;
    
    if (this.hosoSelect.HoVaTen === null || this.hosoSelect.HoVaTen === '') {
      swal('Cảnh báo!', "Bạn chưa nhập họ tên nhân viên", 'warning');
      return;
    }
    if (this.hosoSelect.NameParent === null || this.hosoSelect.NameParent === '') {
      swal('Cảnh báo!', "Bạn chưa nhập tên phụ huynh", 'warning');
      return;
     }
    if (this.hosoSelect.PhoneParent === null || this.hosoSelect.PhoneParent === '') {
      swal('Cảnh báo!', "Bạn chưa nhập điện thoại phụ huynh", 'warning');
      return;
    }


    //if (this.hosoSelect.MaNV === null || this.hosoSelect.MaNV === '') {
    //  swal('Cảnh báo!', "Bạn chưa nhập mã số hồ sơ", 'warning');
    //  return;
    //}



    if (this.hosoSelect.DonViId === null) {
      swal('Cảnh báo!', "Bạn chưa nhập chi nhánh", 'warning');
      return;
    }

    //if (this.hosoSelect.IdConsult === null) {
    //  swal('Cảnh báo!', "Bạn chưa nhập phụ trách", 'warning');
    //  return;
    //} 

    //if (this.hosoSelect.BoPhanId === null || this.hosoSelect.BoPhanId === '') {
    //  swal('Cảnh báo!', "Bạn chưa nhập bộ phận", 'warning');
    //  return;
    //}
    //if (this.hosoSelect.ChucVuId === null || this.hosoSelect.ChucVuId === '') {
    //  swal('Cảnh báo!', "Bạn chưa nhập chức vụ", 'warning');
    //  return;
    //}


    //if (this.hosoSelect.GioiTinh === null || this.hosoSelect.GioiTinh === '') {
    //  swal('Cảnh báo!', "Bạn chưa nhập giới tính", 'warning');
    //  return;
    //}


    if (this.hosoSelect.NoiSinhIdSelect != null && this.hosoSelect.NoiSinhIdSelect != {})
      this.hosoSelect.NoiSinhId = this.hosoSelect.NoiSinhIdSelect.id;
    if (this.hosoSelect.NguyenQuanIdSelect != null && this.hosoSelect.NguyenQuanIdSelect != {})
      this.hosoSelect.NguyenQuanId = this.hosoSelect.NguyenQuanIdSelect.id;

    if (this.hosoSelect.HoKhauThuongTruIdSelect != null && this.hosoSelect.HoKhauThuongTruIdSelect != {})
      this.hosoSelect.HoKhauThuongTruId = this.hosoSelect.HoKhauThuongTruIdSelect.id;
    if (this.hosoSelect.ChoOHienTaiIdSelect != null && this.hosoSelect.ChoOHienTaiIdSelect != {})
      this.hosoSelect.ChoOHienTaiId = this.hosoSelect.ChoOHienTaiIdSelect.id;



    if (this.hosoSelect.NgayVaoDang != null)
      this.hosoSelect.NgayVaoDang_S = this.hosoSelect.NgayVaoDang.getDate() + '/' + (this.hosoSelect.NgayVaoDang.getMonth() + 1) + '/' + this.hosoSelect.NgayVaoDang.getFullYear();
    if (this.hosoSelect.NgayRaDang != null)
      this.hosoSelect.NgayRaDang_S = this.hosoSelect.NgayRaDang.getDate() + '/' + (this.hosoSelect.NgayRaDang.getMonth() + 1) + '/' + this.hosoSelect.NgayRaDang.getFullYear();
    if (this.hosoSelect.NgayVaoDangCT != null)
      this.hosoSelect.NgayVaoDangCT_S = this.hosoSelect.NgayVaoDangCT.getDate() + '/' + (this.hosoSelect.NgayVaoDangCT.getMonth() + 1) + '/' + this.hosoSelect.NgayVaoDangCT.getFullYear();
    if (this.hosoSelect.NgayCapTheDang != null)
      this.hosoSelect.NgayCapTheDang_S = this.hosoSelect.NgayCapTheDang.getDate() + '/' + (this.hosoSelect.NgayCapTheDang.getMonth() + 1) + '/' + this.hosoSelect.NgayCapTheDang.getFullYear();
    if (this.hosoSelect.NgayVaoDoan != null)
      this.hosoSelect.NgayVaoDoan_S = this.hosoSelect.NgayVaoDoan.getDate() + '/' + (this.hosoSelect.NgayVaoDoan.getMonth() + 1) + '/' + this.hosoSelect.NgayVaoDoan.getFullYear();

    //if (this.hosoSelect.NgaySinh_S != "")
    //  this.hosoSelect.NgaySinh_S = this.ejNgaySinh.getMaskedValue();
    $('#loading').show();
    this.repo.postRequest("api/tuyensinh/addorupdate_hocvien_CtuV2", this.hosoSelect)
      .subscribe(response => {
        $('#loading').hide();
        if (response === "OK") {
          //this.hosoSelect.Id = response.Data;
          this.save.emit(this.hosoSelect);
        }
        else
          swal('Cảnh báo!', response, 'warning');
      });

  }

  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }

  adddata_danhsachlichhoc() {
    if (this.hosoSelect.Id !== null) {
      this.dtedslichhocedit.loadDataInit(this.hosoSelect.Id, KhoaHocs_KhoaHoc.id);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.mdDanhSachLichHoc.open();
    }
    else {
      swal('Lỗi!', 'Phải thêm lớp học trước khi thêm lịch học!.', 'error');
      return;
    }

  }
  save_danhsachlichhoc(doituong: any) {
    this.mdDanhSachLichHoc.close();
  }


  removeaccount() {
    this.hosoSelect.TaiKhoan = null;
    this.hosoSelect.UserId = null;
  }
  adddata() {
    this.dteChonTaiKhoan.loadDataInit(null, 0, this.phanheid, null);
    this.modal.open();
  }
  savetaikhoan(doituong1: any) {
    console.log(doituong1)
    this.hosoSelect.TaiKhoan = doituong1.UserName;
    this.hosoSelect.UserId = doituong1.Id;
    this.modal.close();
  }

}

